
export enum WhatsAppStatus {
    Queued = 'queued',
    Sending = 'sending',
    Sent = 'sent',
    Failed = 'failed',
    Delivered = 'delivered',
    Undelivered = 'undelivered',
    Read = 'read',
    Pending = 'pending',
    Received = 'received'
  }